import {
  HierarchyPointNode,
} from 'd3-hierarchy';

const newFlatten = <T>(listOfLists: T[][]): T[] => {
  const result: T[] = [];
  for (const list of listOfLists) {
    for (const elem of list) {
      result.push(elem);
    }
  }
  return result;
};

const flattenTree = <Datum>(node: HierarchyPointNode<Datum>): Array<HierarchyPointNode<Datum>> => {
  if (node.children === undefined) {
    return [node];
  } else {
    const children = node.children.map(child => flattenTree(child));
    const flattened = newFlatten(children);
    return [node, ...flattened];
  }
};

export default flattenTree;
